const routes = [
  {
    path: '/m/home',
    name: 'm-home',
    component: () => import('@/views/home/mIndex.vue'),
    meta: {
      title: 'WPS 365 教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/2023/home',
    name: 'm-home2023',
    component: () => import('@/views/home2023/mIndex.vue'),
    meta: {
      title: 'WPS Office 2023 教育版- 满足大中小学教育客户多样化教学办公需求，帮助您的机构简化工作、提升效率-WPS Office 2023 教育版官网'
    }
  },
  {
    path: '/m/help',
    name: 'm-help',
    component: () => import('@/views/help/mIndex.vue'),
    meta: {
      title: 'WPS 365 教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/helplist',
    name: 'm-helplist',
    component: () => import('@/views/help/HelpList.vue'),
    meta: {
      title: 'WPS 365 教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/price',
    name: 'price',
    component: () => import('@/views/price/src/Index.vue'),
    meta: {
      title: 'WPS 365 教育版-WPS 365 教育版官网-正版WPS- 在线文档-WPS云盘'
    }
  },
  {
    path: '/m/download',
    name: 'download',
    redirect: '/m/home',
  },
];

export default routes;
